exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag_class[data-v-0bc5b6ee]{text-align:right;position:absolute;background-color:#d70c12;color:#fff;right:0;bottom:5px;padding:3px;background-color:rgba(215,12,18,.7)}.price_class[data-v-0bc5b6ee]{font-size:15px;bottom:0}", ""]);

// exports
